import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

export const useAppDispatch = () => useDispatch<ThunkDispatch<any, any, any>>();
export const useAppSelector = useSelector;
